import { render } from "./DatasetMethod.vue?vue&type=template&id=2fef746b"
import script from "./DatasetMethod.vue?vue&type=script&lang=js"
export * from "./DatasetMethod.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__